'use client';

import { CustomerType, IVehicleConfiguration } from 'next-common';
import { IVehicleListOrderProps, IVehiclePageProps, packageAppendingPath } from '@common';
import { getAppendingIdFromUrl, getAppendingNumericIdFromUrl } from '@utils';
import { IVehicleDetailsPageProps } from '@components/sales/sales-finance-page';
import { IPages } from '@components/sales/sales-wizard';
import { setCustomerType } from '@store/slices/customerSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';

export const getOrderId = (appendingPath = '') => getAppendingNumericIdFromUrl(appendingPath);

const getPickerPageProps = (getOrderParams: (vehicle: IVehicleConfiguration) => IVehicleListOrderProps) => {
  return {
    orderId: getOrderId(),
    getUpdateOrderVariables: getOrderParams,
  };
};

const getVehiclePageProps = (appendingPath = ''): IVehiclePageProps => ({
  orderId: getOrderId(appendingPath),
});

const getPageProps = (customerType: CustomerType, dispatch: ThunkDispatch<any, any, any>): IVehicleDetailsPageProps => {
  return {
    ...getVehiclePageProps(),
    customerType,
    pimCode: null,
    onCustomerType: (type: CustomerType) => dispatch(setCustomerType(type)),
  };
};

// const getAccessoriesPageProps = (): IVehicleAccessoriesPageProps => {
//   return getVehiclePageProps();
// };

export const pageProps = (
  customerType: CustomerType,
  getOrderParams: (vehicle: IVehicleConfiguration) => IVehicleListOrderProps,
  dispatch: ThunkDispatch<any, any, any>
): IPages => {
  const packages = {
    ...getVehiclePageProps(packageAppendingPath),
    pimId: getAppendingIdFromUrl(),
  };

  return {
    picker: getPickerPageProps(getOrderParams),
    details: getPageProps(customerType, dispatch),
    finance: getPageProps(customerType, dispatch),
    signing: getPageProps(customerType, dispatch),
    packages,
  };
};
